import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { Debounce } from 'react-throttle';
import WindowResizeListener from 'react-window-size-listener';
import campaignActions from '../../redux/campaign/actions';
import { ThemeProvider } from 'styled-components';
import authAction from '../../redux/auth/actions';
import appActions from '../../redux/app/actions';
import csvActions from '../../redux/csvtemplates/actions';
import Sidebar from './Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AdvertiserRouter from './AppRouter';
import { siteConfig } from '../../settings';
import themes from '../../settings/themes';
import { themeConfig } from '../../settings';
import AppHolder from '../App/commonStyle';
import '../App/global.css';

const { Content, Footer } = Layout;
const { logout } = authAction;
const { toggleAll } = appActions;
export class ReportsApp extends Component {
  
  shouldHaveSidebar = () => {
    const {campaigns, campaign} = this.props;
    if(campaigns.length > 0 && campaign !== null) return true;
    return false;
  };
  
  componentDidMount()
  {
    const {campaigns, isFetchingCampaigns, fetchCampaigns, fetchCsvTemplates} = this.props;
    if(campaigns.length > 0 || isFetchingCampaigns) return;
    fetchCampaigns();
    fetchCsvTemplates();
  }
  
  render() {
    const { url } = this.props.match;
    const { height } = this.props;
    const appHeight = window.innerHeight;
    // const shouldHaveSidebar = this.shouldHaveSidebar();
    
    return (
      <ThemeProvider theme={themes[themeConfig.theme]}>
        <AppHolder>
          <Layout style={{ height: appHeight }}>
            <Debounce time="1000" handler="onResize">
              <WindowResizeListener
                onResize={windowSize =>
                  this.props.toggleAll(
                    windowSize.windowWidth,
                    windowSize.windowHeight
                  )
                }
              />
            </Debounce>
            <Topbar url={url} haveSidebar={true} />
            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
              <Sidebar url={url} visible={true} />
              <Layout
                className="isoContentMainLayout"
                style={{
                  height: height
                }}
              >
                <Content
                  className="isomorphicContent"
                  style={{
                    padding: '70px 0 0 8px',
                    flexShrink: '0',
                    background: '#f1f3f6',
                    position: 'relative'
                  }}
                >
                  <AdvertiserRouter url={url} />
                </Content>
                <Footer
                  style={{
                    background: '#ffffff',
                    textAlign: 'center',
                    borderTop: '1px solid #ededed'
                  }}
                >
                  {siteConfig.footerText} <span style={{color: '#dddddd'}}> (v{siteConfig.appVersion})</span>
                </Footer>
              </Layout>
            </Layout>
          </Layout>
        </AppHolder>
      </ThemeProvider>
    );
  }
}

const {fetchCampaigns} = campaignActions;
const {fetchCsvTemplates} = csvActions;

export default connect(
  state => ({
    auth: state.Auth,
    height: state.App.height,
    campaigns: state.Campaigns.campaigns,
    isFetchingCampaigns: state.Campaigns.isFetching,
  }),
  { logout, toggleAll, fetchCampaigns, fetchCsvTemplates}
)(ReportsApp);
